import React from "react";
import "./Podium.css";

const Podium = ({topThree}) => {
    if(topThree.length === 0){
        return <p>Wait.....</p>
    }
      return (
        <div className="leaderboard">
          {topThree
            .map((person, index) => (
              <div key={person._id} className="podium">
                <div className="name">{person.name}</div>
                <div className="score">{person.score} pts</div>
                <div className={`stage stage-${person.rank}`}></div>
              </div>
            ))}
        </div>
      );
};
export default Podium;